// Import models.
import PolicyCost from './PolicyCost';
// Import enumerations.
import {
	PolicyTermStatus,
} from '@app/enumerations';

export default class PolicyTermWithStatus {
	public termYear: number | null = null;
	public effectiveDate: Date | null = null;
	public endDate: Date | null = null;
	public termStatus: PolicyTermStatus | null = null;
	public cost: PolicyCost | null = null;

	public constructor() {

	}
}